import { NgModule } from '@angular/core';

import { RouterModule, Routes } from '@angular/router';
import { RegistrationByEdsComponent } from './registration-by-eds/registration-by-eds.component';
import { RegisterOrganizationComponent } from './register-organization/register-organization.component';
import { RegistrationBySmsComponent } from './registration-by-sms/registration-by-sms.component';

const routes: Routes = [
  {
    path: 'select-eds', component: RegistrationByEdsComponent,
  },
  {
    path: 'add-phone', component: RegistrationBySmsComponent,
  },
  {
    path: 'fill-form', component: RegisterOrganizationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RegistrationRoutingModule {
}
